import CrudTable, { TextField, CheckField, JsonField } from './CrudTable';

export default function AdminPricing() {
  return (
    <CrudTable
      table="pricing"
      title="Pricing plans"
      itemLabel="pricing plan"
      defaults={{ name: '', tagline: '', price: 4900, billing: 'project', features: [], cta: 'Start a project', featured: false, order_index: 0 }}
      columns={[
        { key: 'name', label: 'Name', className: 'col-span-3' },
        { key: 'price', label: 'Price', className: 'col-span-2', format: v => v ? `$${v}` : 'Custom' },
        { key: 'billing', label: 'Billing', className: 'col-span-2' },
        { key: 'featured', label: 'Featured', className: 'col-span-3', format: v => v ? 'Yes' : 'No' },
      ]}
      render={(it, set) => (
        <>
          <TextField label="Name" value={it.name} onChange={v => set({ ...it, name: v })} required />
          <TextField label="Tagline" value={it.tagline} onChange={v => set({ ...it, tagline: v })} />
          <TextField label="Price ($)" type="number" value={it.price} onChange={v => set({ ...it, price: v })} />
          <TextField label="Billing" value={it.billing} onChange={v => set({ ...it, billing: v })} />
          <TextField label="CTA label" value={it.cta} onChange={v => set({ ...it, cta: v })} />
          <JsonField label="Features" value={it.features} onChange={v => set({ ...it, features: v })} />
          <CheckField label="Featured" value={it.featured} onChange={v => set({ ...it, featured: v })} />
          <TextField label="Order" type="number" value={it.order_index} onChange={v => set({ ...it, order_index: v })} />
        </>
      )}
    />
  );
}
